
import DataInsertion from '../components/DataInsertion';

const Insercion = () => {
    return (
        <DataInsertion />
    );
}

export default Insercion;